import React, { forwardRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { motion } from 'framer-motion'
import { useModal } from 'components/modals'
import { Close } from '@mui/icons-material'
import { useState } from 'react'
import { ArrowBack } from '@mui/icons-material'

import piggy from 'assets/images/onboarding/piggy.png'
import OnboardingTSP from 'components/OnboardingTSP'
import OnboardingMultiSelectTile from 'components/OnboardingMultiSelectTile'
import { ScheduleAppointment } from 'components/ScheduleAppointment'
import { ScheduleMeeting } from 'components/ScheduleMeeting'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function ContributeTSP({
  onClose,
  //   nextButtonText = 'Start Contributing',
  buttonColor = '#2370ED',
  buttonHoverColor = '#1c59bd',
  //   cancelButtonText = '',
  showAction = true,
  currentContribution = 2,
  openTo,
}) {
  //action/text changes based on what we want them to do
  const pages = [
    //FLOW 1 NO CONTRIBUTION, eventually link to something outwardly actionable (like actually contributing to your TSP)
    {
      id: 'noContribution',
      header: 'Make sure you contribute to your TSP',
      body: 'Looks like you aren’t currently contributing to your TSP. Start growing your nest egg—every dollar in your TSP is tax-advantaged savings for future you. The earlier you start contributing, the better: www.tsp.gov/contributions(fake URL)',
      nextButtonText: 'Start Contributing',
      cancelButtonText: 'I am already contributing',
      image: piggy,
      nextPage: 1,
    },

    {
      id: 'startContributing',
      backPage: 0,
      nextPage: 2,
      header: 'Which TSPs do you contribute to?',
      customSection: (
        <OnboardingMultiSelectTile
          preHeader={''}
          header=" "
          subHeader="Select all that apply:"
          helpText=""
          tileSize={{ xs: '6', sm: '4' }}
          questionArray={[
            {
              id: 'tsp',
              optionLabel: 'TSP Traditional',
            },
            {
              id: 'tspRoth',
              optionLabel: 'TSP Roth',
            },
            {
              id: '',
              optionLabel: 'Neither',
            },
          ]}
        />
      ),
    },

    {
      id: 'adjustContribution',
      backPage: 1,
      header: 'How much are you contributing to the TSP?',
      nextButtonText: 'Save',
      customSection: <OnboardingTSP isTodo />,
    },

    //FLOW 2 NOT 5 PERCENT
    {
      id: 'not5Percent',
      header: 'Up your TSP Contribution from ' + currentContribution + '% → 5%',
      body: '5% is the bare-minimum—it takes full advantage of your government match and maximizes free money. The more you contribute, and the earlier you do it, the better. Login to your agency payroll to up your contribution amount.',
      nextButtonText: 'I am already contributing 5%',
      hideCancel: true,
      image: piggy,

      nextPage: 4,
    },

    {
      id: 'adjustContribution',
      backPage: 3,
      header: 'How much are you contributing to the TSP?',
      nextButtonText: 'Save',
      customSection: (
        <>
          <OnboardingTSP isTodo />
        </>
      ),
    },

    {
      id: 'gFundAlternates',
      header:
        'See how you can get the same benefits of the G-Fund with less drawbacks',
      body: 'We see you have an annuity with North American. Schedule a time to meet with a PARCO team-member so we can review the quality of your annuity.',
      hideNext: true,
      hideCancel: true,

      customSection: (
        <>
          <Box sx={{ scale: 0.99 }}>
            <ScheduleMeeting isOnModal />
          </Box>
        </>
      ),
    },
  ]

  const { openModal } = useModal()

  const [page, setPage] = useState(openTo)

  const renderPage = (page) => {
    if (!page) return null

    if (page.customLayout) return page.customLayout

    return (
      <Box p={3}>
        {page.header && (
          <Typography variant="headerTitle" sx={{ color: '#262627' }}>
            {page.header}
          </Typography>
        )}

        {page.body && (
          <Typography variant="body1" mt={page.header ? 3 : 0}>
            {page.body}
          </Typography>
        )}

        {page.customSection && (
          <Box mt={page.header || page.body ? 3 : 0}>{page.customSection}</Box>
        )}

        {page.image && (
          <Box
            component="img"
            src={page.image}
            sx={{
              width: '100%',
              maxWidth: { xs: 150, sm: 200 },
              display: 'block',
              mx: 'auto',
            }}
          />
        )}

        <Box display="flex" justifyContent="flex-end" gap={4} mt={3}>
          {!page.hideCancel && (
            <Button onClick={onClose} variant="parcoRounded" color="outline">
              {page.cancelButtonText || (showAction ? 'Cancel' : 'Close')}
            </Button>
          )}

          {!page.hideNext && (
            <Button
              onClick={() => {
                if (page.nextPage !== undefined) setPage(page.nextPage)
                else {
                  onClose()
                }
              }}
              variant="parcoRounded"
            >
              {page.nextButtonText || 'Next'}
            </Button>
          )}
        </Box>
      </Box>
    )
  }

  const currentPage = pages[page]

  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'md'}
      PaperProps={{ sx: { overflow: 'visible', maxHeight: '80vh' } }}
    >
      <Box
        sx={{
          justifyContent: 'space-between',
          position: 'relative',
          top: -64,
        }}
      >
        {currentPage.backPage !== undefined && (
          <IconButton
            onClick={() => {
              setPage(currentPage.backPage)
            }}
            sx={{
              position: 'absolute',
              top: 0,
              left: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <ArrowBack />
          </IconButton>
        )}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 0,
            right: -16,
            color: '#fff',
            zIndex: 1,
            backgroundColor: '#000',
            '&:hover': {
              backgroundColor: '#000',
            },
          }}
        >
          <Close />
        </IconButton>
      </Box>
      <DialogContent sx={{ overflow: 'scroll' }}>
        {renderPage(currentPage)}
      </DialogContent>
    </Dialog>
  )
}
